export default "__VITE_ASSET__2a15d725__"